import { onDocumentReady, initStackedSlider, setupStackedSliderHeight } from '../../utils/stacked-slider';

onDocumentReady( () => {
    document.querySelectorAll( '.reviews-slider' ).forEach( ( slider ) => {
        slider.classList.add( 'reviews-slider--enhanced' );

        const heightManager = setupStackedSliderHeight( slider, {
            wrapperSelector: '.reviews-slider__slides',
            slideSelector: '.reviews-slide',
        } );

        initStackedSlider( slider, {
            slideSelector: '.reviews-slide',
            dotsContainerSelector: '.reviews-slider__dots',
            prevArrowSelector: '.reviews-slider__arrow--prev',
            nextArrowSelector: '.reviews-slider__arrow--next',
            dotAriaLabel: ( index ) => `Opinia ${ index + 1 }`,
            onSlideChange: ( detail ) => {
                if ( heightManager ) {
                    heightManager.observe( detail.currentSlide );
                    heightManager.schedule();
                }
            },
        } );

        if ( heightManager ) {
            const initialSlide = slider.querySelector( '.reviews-slide' );
            heightManager.observe( initialSlide );
            heightManager.schedule();
        }
    } );
} );
